import { __decorate } from 'tslib';
import { NgStyle } from '@angular/common';
import * as i0 from '@angular/core';
import { numberAttribute, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, inject, booleanAttribute, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { zoomBadgeMotion } from 'ng-zorro-antd/core/animation';
import * as i1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import * as i3 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i2 from '@angular/cdk/bidi';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function NzBadgeSupComponent_Conditional_0_For_1_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const p_r1 = ctx.$implicit;
    const ɵ$index_2_r2 = i0.ɵɵnextContext(2).$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("current", p_r1 === ctx_r2.countArray[ɵ$index_2_r2]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", p_r1, " ");
  }
}
function NzBadgeSupComponent_Conditional_0_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NzBadgeSupComponent_Conditional_0_For_1_Conditional_1_For_1_Template, 2, 3, "p", 2, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r2.countSingleArray);
  }
}
function NzBadgeSupComponent_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtemplate(1, NzBadgeSupComponent_Conditional_0_For_1_Conditional_1_Template, 2, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_2_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("transform", "translateY(" + -ctx_r2.countArray[ɵ$index_2_r2] * 100 + "%)");
    i0.ɵɵproperty("nzNoAnimation", ctx_r2.noAnimation);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.nzDot && ctx_r2.countArray[ɵ$index_2_r2] !== undefined ? 1 : -1);
  }
}
function NzBadgeSupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NzBadgeSupComponent_Conditional_0_For_1_Template, 2, 4, "span", 0, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.maxNumberArray);
  }
}
function NzBadgeSupComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.nzOverflowCount, "+ ");
  }
}
const _c0 = ["*"];
function NzBadgeComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.nzText);
  }
}
function NzBadgeComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
    i0.ɵɵelementStart(1, "span", 2);
    i0.ɵɵtemplate(2, NzBadgeComponent_Conditional_0_ng_container_2_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ant-badge-status-dot ant-badge-status-", ctx_r0.nzStatus || ctx_r0.presetColor, "");
    i0.ɵɵstyleProp("background", !ctx_r0.presetColor && ctx_r0.nzColor);
    i0.ɵɵproperty("ngStyle", ctx_r0.nzStyle);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzText);
  }
}
function NzBadgeComponent_ng_container_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-badge-sup", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("nzOffset", ctx_r0.nzOffset)("nzSize", ctx_r0.nzSize)("nzTitle", ctx_r0.nzTitle)("nzStyle", ctx_r0.nzStyle)("nzDot", ctx_r0.nzDot)("nzOverflowCount", ctx_r0.nzOverflowCount)("disableAnimation", !!(ctx_r0.nzStandalone || ctx_r0.nzStatus || ctx_r0.nzColor || (ctx_r0.noAnimation == null ? null : ctx_r0.noAnimation.nzNoAnimation)))("nzCount", ctx_r0.nzCount)("noAnimation", !!(ctx_r0.noAnimation == null ? null : ctx_r0.noAnimation.nzNoAnimation));
  }
}
function NzBadgeComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NzBadgeComponent_ng_container_2_Conditional_1_Template, 1, 9, "nz-badge-sup", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showSup ? 1 : -1);
  }
}
function NzRibbonComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.nzText);
  }
}
let NzBadgeSupComponent = /*#__PURE__*/(() => {
  class NzBadgeSupComponent {
    constructor() {
      this.nzStyle = null;
      this.nzDot = false;
      this.nzOverflowCount = 99;
      this.disableAnimation = false;
      this.noAnimation = false;
      this.nzSize = 'default';
      this.maxNumberArray = [];
      this.countArray = [];
      this.count = 0;
      this.countSingleArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    }
    generateMaxNumberArray() {
      this.maxNumberArray = this.nzOverflowCount.toString().split('');
    }
    ngOnInit() {
      this.generateMaxNumberArray();
    }
    ngOnChanges(changes) {
      const {
        nzOverflowCount,
        nzCount
      } = changes;
      if (nzCount && typeof nzCount.currentValue === 'number') {
        this.count = Math.max(0, nzCount.currentValue);
        this.countArray = this.count.toString().split('').map(item => +item);
      }
      if (nzOverflowCount) {
        this.generateMaxNumberArray();
      }
    }
    static {
      this.ɵfac = function NzBadgeSupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBadgeSupComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzBadgeSupComponent,
        selectors: [["nz-badge-sup"]],
        hostAttrs: [1, "ant-scroll-number"],
        hostVars: 17,
        hostBindings: function NzBadgeSupComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@.disabled", ctx.disableAnimation)("@zoomBadgeMotion", undefined);
            i0.ɵɵattribute("title", ctx.nzTitle === null ? "" : ctx.nzTitle || ctx.nzCount);
            i0.ɵɵstyleMap(ctx.nzStyle);
            i0.ɵɵstyleProp("right", ctx.nzOffset && ctx.nzOffset[0] ? -ctx.nzOffset[0] : null, "px")("margin-top", ctx.nzOffset && ctx.nzOffset[1] ? ctx.nzOffset[1] : null, "px");
            i0.ɵɵclassProp("ant-badge-count", !ctx.nzDot)("ant-badge-count-sm", ctx.nzSize === "small")("ant-badge-dot", ctx.nzDot)("ant-badge-multiple-words", ctx.countArray.length >= 2);
          }
        },
        inputs: {
          nzOffset: "nzOffset",
          nzTitle: "nzTitle",
          nzStyle: "nzStyle",
          nzDot: "nzDot",
          nzOverflowCount: [2, "nzOverflowCount", "nzOverflowCount", numberAttribute],
          disableAnimation: "disableAnimation",
          nzCount: "nzCount",
          noAnimation: "noAnimation",
          nzSize: "nzSize"
        },
        exportAs: ["nzBadgeSup"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "ant-scroll-number-only", 3, "nzNoAnimation", "transform"], [1, "ant-scroll-number-only", 3, "nzNoAnimation"], [1, "ant-scroll-number-only-unit", 3, "current"], [1, "ant-scroll-number-only-unit"]],
        template: function NzBadgeSupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NzBadgeSupComponent_Conditional_0_Template, 2, 0)(1, NzBadgeSupComponent_Conditional_1_Template, 1, 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.count <= ctx.nzOverflowCount ? 0 : 1);
          }
        },
        dependencies: [NzNoAnimationDirective],
        encapsulation: 2,
        data: {
          animation: [zoomBadgeMotion]
        },
        changeDetection: 0
      });
    }
  }
  return NzBadgeSupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const badgePresetColors = ['pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime'];
const NZ_CONFIG_MODULE_NAME = 'badge';
let NzBadgeComponent = /*#__PURE__*/(() => {
  class NzBadgeComponent {
    constructor(nzConfigService, renderer, cdr, elementRef, directionality) {
      this.nzConfigService = nzConfigService;
      this.renderer = renderer;
      this.cdr = cdr;
      this.elementRef = elementRef;
      this.directionality = directionality;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.showSup = false;
      this.presetColor = null;
      this.dir = 'ltr';
      this.destroy$ = new Subject();
      this.nzShowZero = false;
      this.nzShowDot = true;
      this.nzStandalone = false;
      this.nzDot = false;
      this.nzOverflowCount = 99;
      this.nzColor = undefined;
      this.nzStyle = null;
      this.nzText = null;
      this.nzSize = 'default';
      this.noAnimation = inject(NzNoAnimationDirective, {
        host: true,
        optional: true
      });
    }
    ngOnInit() {
      this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe(direction => {
        this.dir = direction;
        this.prepareBadgeForRtl();
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
      this.prepareBadgeForRtl();
    }
    ngOnChanges(changes) {
      const {
        nzColor,
        nzShowDot,
        nzDot,
        nzCount,
        nzShowZero
      } = changes;
      if (nzColor) {
        this.presetColor = this.nzColor && badgePresetColors.indexOf(this.nzColor) !== -1 ? this.nzColor : null;
      }
      if (nzShowDot || nzDot || nzCount || nzShowZero) {
        this.showSup = this.nzShowDot && this.nzDot || typeof this.nzCount === 'number' && this.nzCount > 0 || typeof this.nzCount === 'number' && this.nzCount <= 0 && this.nzShowZero;
      }
    }
    prepareBadgeForRtl() {
      if (this.isRtlLayout) {
        this.renderer.addClass(this.elementRef.nativeElement, 'ant-badge-rtl');
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement, 'ant-badge-rtl');
      }
    }
    get isRtlLayout() {
      return this.dir === 'rtl';
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    static {
      this.ɵfac = function NzBadgeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBadgeComponent)(i0.ɵɵdirectiveInject(i1.NzConfigService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.Directionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzBadgeComponent,
        selectors: [["nz-badge"]],
        hostAttrs: [1, "ant-badge"],
        hostVars: 4,
        hostBindings: function NzBadgeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-badge-status", ctx.nzStatus)("ant-badge-not-a-wrapper", !!(ctx.nzStandalone || ctx.nzStatus || ctx.nzColor));
          }
        },
        inputs: {
          nzShowZero: [2, "nzShowZero", "nzShowZero", booleanAttribute],
          nzShowDot: [2, "nzShowDot", "nzShowDot", booleanAttribute],
          nzStandalone: [2, "nzStandalone", "nzStandalone", booleanAttribute],
          nzDot: [2, "nzDot", "nzDot", booleanAttribute],
          nzOverflowCount: "nzOverflowCount",
          nzColor: "nzColor",
          nzStyle: "nzStyle",
          nzText: "nzText",
          nzTitle: "nzTitle",
          nzStatus: "nzStatus",
          nzCount: "nzCount",
          nzOffset: "nzOffset",
          nzSize: "nzSize"
        },
        exportAs: ["nzBadge"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [[4, "nzStringTemplateOutlet"], [3, "ngStyle"], [1, "ant-badge-status-text"], [3, "nzOffset", "nzSize", "nzTitle", "nzStyle", "nzDot", "nzOverflowCount", "disableAnimation", "nzCount", "noAnimation"]],
        template: function NzBadgeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NzBadgeComponent_Conditional_0_Template, 3, 7);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, NzBadgeComponent_ng_container_2_Template, 2, 1, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.nzStatus || ctx.nzColor ? 0 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("nzStringTemplateOutlet", ctx.nzCount);
          }
        },
        dependencies: [NgStyle, NzBadgeSupComponent, NzOutletModule, i3.NzStringTemplateOutletDirective],
        encapsulation: 2,
        data: {
          animation: [zoomBadgeMotion]
        },
        changeDetection: 0
      });
    }
  }
  __decorate([WithConfig()], NzBadgeComponent.prototype, "nzOverflowCount", void 0);
  __decorate([WithConfig()], NzBadgeComponent.prototype, "nzColor", void 0);
  return NzBadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzRibbonComponent = /*#__PURE__*/(() => {
  class NzRibbonComponent {
    constructor() {
      this.nzPlacement = 'end';
      this.nzText = null;
      this.presetColor = null;
    }
    ngOnChanges(changes) {
      const {
        nzColor
      } = changes;
      if (nzColor) {
        this.presetColor = this.nzColor && badgePresetColors.indexOf(this.nzColor) !== -1 ? this.nzColor : null;
      }
    }
    static {
      this.ɵfac = function NzRibbonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzRibbonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzRibbonComponent,
        selectors: [["nz-ribbon"]],
        hostAttrs: [1, "ant-ribbon-wrapper"],
        inputs: {
          nzColor: "nzColor",
          nzPlacement: "nzPlacement",
          nzText: "nzText"
        },
        exportAs: ["nzRibbon"],
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 11,
        consts: [[1, "ant-ribbon"], [4, "nzStringTemplateOutlet"], [1, "ant-ribbon-corner"], [1, "ant-ribbon-text"]],
        template: function NzRibbonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵelementStart(1, "div", 0);
            i0.ɵɵtemplate(2, NzRibbonComponent_ng_container_2_Template, 3, 1, "ng-container", 1);
            i0.ɵɵelement(3, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.presetColor && "ant-ribbon-color-" + ctx.presetColor);
            i0.ɵɵstyleProp("background-color", !ctx.presetColor && ctx.nzColor);
            i0.ɵɵclassProp("ant-ribbon-placement-end", ctx.nzPlacement === "end")("ant-ribbon-placement-start", ctx.nzPlacement === "start");
            i0.ɵɵadvance();
            i0.ɵɵproperty("nzStringTemplateOutlet", ctx.nzText);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("color", !ctx.presetColor && ctx.nzColor);
          }
        },
        dependencies: [NzOutletModule, i3.NzStringTemplateOutletDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzRibbonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzBadgeModule = /*#__PURE__*/(() => {
  class NzBadgeModule {
    static {
      this.ɵfac = function NzBadgeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBadgeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzBadgeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzBadgeComponent, NzRibbonComponent]
      });
    }
  }
  return NzBadgeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzBadgeComponent, NzBadgeModule, NzRibbonComponent };
